import { X, AlertTriangle } from "lucide-react";

export default function DeleteConfirmationModal({ isOpen, onClose, onConfirm, itemName }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center font-dynamic-title justify-center p-4 bg-slate-900/40 backdrop-blur-sm z-50 animate-fade-in">
      <div className="bg-white rounded-xl w-full max-w-md shadow-xl border border-slate-100 overflow-hidden transform transition-all animate-scale-in">
        
        {/* Modal Header */}
        <div className="absolute top-0 left-6 right-6 h-[2px] bg-gradient-to-r from-transparent via-[#002855]/30 to-transparent" />
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100 bg-red-50/30">
          <div className="flex items-center gap-2.5">
            <div className="p-1.5 bg-red-100 text-red-600 rounded-lg">
              <AlertTriangle size={16} />
            </div>
            <div>
              <h2 className="text-base font-bold text-slate-900">Confirm Asset Deletion</h2>
              <p className="text-[11px] text-slate-500 mt-0.5">Destructive action security checkpoint</p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-700 transition-colors cursor-pointer"
          >
            <X size={16} />
          </button>
        </div>

        {/* Modal Content */}
        <div className="p-6 text-xs space-y-4">
          <p className="text-slate-600 leading-relaxed font-medium">
            Are you absolutely sure you want to drop the selected data node? This will purge the following record permanently from live server registers:
          </p>
          
          {/* Item Highlight Block */}
          <div className="p-3 bg-slate-50 border border-slate-200/60 rounded-xl font-mono text-slate-700 font-bold tracking-wide select-all truncate">
            {itemName || "Unnamed System Target"}
          </div>

          <div className="flex items-center gap-2 text-[11px] text-red-600 font-semibold bg-red-50/50 p-2.5 border border-red-100/50 rounded-xl">
            <span className="w-1.5 h-1.5 rounded-full bg-red-500 shrink-0" />
            <span>Warning: This pipeline tracking change cannot be undone or reverted.</span>
          </div>

          {/* Action Buttons Sub-Footer */}
          <div className="flex justify-end gap-2 pt-4 border-t border-slate-100 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 font-semibold text-slate-600 bg-white border border-slate-200 hover:bg-slate-50 rounded-xl transition-all cursor-pointer"
            >
              Cancel Operation
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="px-5 py-2 font-bold uppercase tracking-wider text-white bg-red-600 hover:bg-red-700 rounded-xl shadow-sm shadow-red-100 transition-all cursor-pointer active:scale-98"
            >
              Confirm Delete
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}